import {Component} from '@angular/core';
import {SearchService} from '../search.service';

@Component({
    selector: 'app-search-view',
    templateUrl: './search-view.component.html',
    styleUrls: ['./search-view.component.scss'],
    providers: [],
    standalone: false
})
export class SearchViewComponent
{
    isSearchCollapsed: boolean;

    constructor(
        private searchDataService: SearchService)
    {
        this.isSearchCollapsed = this.searchDataService.searchViewCollapsed;
    }

    get currentPage(): number
    {
        return this.searchDataService.currentPage;
    }

    get results()
    {
        return this.searchDataService.results;
    }

    get pager()
    {
        let startPage, endPage: number;

        if (!this.results)
        {
            startPage = 0;
            endPage = 0;
        }
        else if (this.results.totalPages < 5)
        {
            startPage = 0;
            endPage = this.results.totalPages - 1;
        }
        else
        {
            if (this.currentPage < 2)
            {
                startPage = 0;
                endPage = 4;
            }
            else if (this.currentPage + 3 >= this.results.totalPages)
            {
                startPage = this.results.totalPages - 5;
                endPage = this.results.totalPages - 1;
            }
            else
            {
                startPage = this.currentPage - 2;
                endPage = this.currentPage + 2;
            }
        }

        return Array.from(Array((endPage + 1) - startPage).keys()).map(i => startPage + i);
    }

    updatePage(pageNumber: number)
    {
        this.searchDataService.updatePage(pageNumber);

    }

    searchComponentClick()
    {
        this.searchDataService.searchViewCollapsed = !this.searchDataService.searchViewCollapsed;
        this.isSearchCollapsed = this.searchDataService.searchViewCollapsed;
    }
}